module.exports = __webpack_public_path__ + "static/media/tools-multiple-choice.bc32bec4.svg";